import api from "@/lib/axios";

// Taban dildeki metni hedef dile çevirir. Sağlayıcıyı API seçiyor: kiracının pazaryeri bağlantısı
// varsa kanalın kendi modeli, yoksa Workers AI. Boş/başarısızsa '' döner — çağıran sessizce yutar.
//
// `field` kanal yolunda gerekiyor: uç alan adını istiyor ve ürün adına açıklama üslubuyla cevap
// vermiyor. `name`/`category` yalnızca bağlam, ikisi de zorunlu değil.
export const translate = async (
  text,
  target = "en",
  { field = "description", name, category } = {},
) => {
  const trimmed = (text ?? "").trim();
  if (!trimmed) {
    return "";
  }
  const { data } = await api.post("/translate", {
    text: trimmed,
    target,
    field,
    name: name || undefined,
    category: category || undefined,
  });
  return data.data.text ?? "";
};
